export const DOCUMENT_CATEGORY_LIST = "DOCUMENT_CATEGORY_LIST";
export const DOCUMENT_CATEGORY_LIST_SUCCESS = "DOCUMENT_CATEGORY_LIST_SUCCESS";
export const DOCUMENT_CATEGORY_LIST_FAIL = "DOCUMENT_CATEGORY_LIST_FAIL";

/* >>>>>>>>>>>>>> EDIT CUSTOMER >>>>>>>>>>>>>>>*/

export const EDIT_DOCUMENT_CATEGORY = "EDIT_DOCUMENT_CATEGORY";
export const EDIT_DOCUMENT_CATEGORY_SUCCESS = "EDIT_DOCUMENT_CATEGORY_SUCCESS";
export const EDIT_DOCUMENT_CATEGORY_FAIL = "EDIT_DOCUMENT_CATEGORY_FAIL";

/* >>>>>>>>>>>Update User <<<<<<<<<<<<<<< */
export const UPDATE_DOCUMENT_CATEGORY = "UPDATE_DOCUMENT_CATEGORY";
export const UPDATE_DOCUMENT_CATEGORY_SUCCESS =
  "UPDATE_DOCUMENT_CATEGORY_SUCCESS";
export const UPDATE_DOCUMENT_CATEGORY_FAIL = "UPDATE_DOCUMENT_CATEGORY_FAIL";

/* >>>>>>>>Add User <<<<<<<<<<<<<<< */
export const ADD_DOCUMENT_CATEGORY = "ADD_DOCUMENT_CATEGORY";
export const ADD_DOCUMENT_CATEGORY_SUCCESS = "ADD_DOCUMENT_CATEGORY_SUCCESS";
export const ADD_DOCUMENT_CATEGORY_FAIL = "ADD_DOCUMENT_CATEGORY_FAIL";

/* >>>>>>>>>>>>>> DELETE USER >>>>>>>>>>>>>>>*/
export const DELETE_DOCUMENT_CATEGORY = "DELETE_DOCUMENT_CATEGORY";
export const DELETE_DOCUMENT_CATEGORY_SUCCESS =
  "DELETE_DOCUMENT_CATEGORY_SUCCESS";
export const DELETE_DOCUMENT_CATEGORY_FAIL = "DELETE_DOCUMENT_CATEGORY_FAIL";
